<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />

				{{!dataForm.id ? '新增合同' : '修改合同'}}
			</el-col>
			<el-col :xs="24" :md="18" style="text-align: right;">
				<el-button v-no-more-click type="primary" v-if="$hasPermission('plat:platcontract:save')" :loading="loadingbut"
					@click="dataFormSubmitHandle('1')">提交</el-button>
				<el-button v-no-more-click type="primary" v-if="$hasPermission('plat:platcontract:save')" :loading="loadingbut"
					style="background-color: skyblue" @click="dataFormSubmitHandle('0')">保存</el-button>
				<el-button @click="init()" v-if="dataForm.id">刷新</el-button>
				<el-button @click="$router.go(-1)">返回列表</el-button>

			</el-col>
		</el-row>
		<div style="padding: 50px;width: 89%;">
			<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '160px' : '160px'">
        <el-row>
          <el-col :md="12" :lg="12">
						<el-form-item label="甲方主体" :prop="power == 'OPERATE'? 'firstId' : ''">
							<el-input v-if=" power == 'COMPANY'" v-model="dataForm.firstBody" placeholder="甲方主体"  readonly show-word-limit></el-input>
							<el-select v-if="power == 'OPERATE'" v-model="dataForm.firstBody" placeholder="甲方主体" filterable  @change="jiafang"
								style="width: 95%;">
								<el-option v-for="platBody in firstBody" :key="platBody.id" :label="platBody.caName"
									:value="platBody.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
           <!-- <el-col :md="12" :lg="12">
						<el-form-item label="乙方主体" prop="secondBody">
							<el-input v-model="dataForm.secondBody" placeholder="乙方主体"  readonly ></el-input>
						</el-form-item>
					</el-col> -->
          <el-col :md="12" :lg="12">
						<el-form-item label="乙方主体" prop="secondBody">
              <el-select v-model="dataForm.secondBody" placeholder="请选择" style="width: 95%;" clearable filterable @change="sydChange">
                <el-option
                  v-for="item in secondBody"
                  :key="item.id"
                  :label="`${item.abbreviation}`"
                  :value="item">
                </el-option>
              </el-select>
						</el-form-item>
					</el-col>
        </el-row>
         <el-row>
          <el-col :md="12" :lg="12">
						<el-form-item label="甲方联系人" prop="firstUser">
							<el-input v-model="dataForm.firstUser" style="width: 95%;" placeholder="甲方联系人"
									   	 show-word-limit></el-input>
						</el-form-item>
					</el-col>
          <!-- <el-col :md="12" :lg="12">
						<el-form-item label="乙方联系人" prop="secondUser">
							<el-input v-model="dataForm.secondUser" style="width: 95%;" placeholder="乙方联系人"
									   show-word-limit></el-input>
						</el-form-item>
					</el-col> -->
          <el-col :md="12" :lg="12">
						<el-form-item label="乙方联系人" prop="secondUser">
							<el-input v-model="dataForm.secondUser" style="width: 95%;" placeholder="乙方联系人"
									   show-word-limit></el-input>
						</el-form-item>
					</el-col>
        </el-row>
        <el-row>
          <el-col :md="12" :lg="12">
						<el-form-item label="甲方联系电话" prop="firstPhone">
							<el-input style="width: 95%;" v-model="dataForm.firstPhone" placeholder="甲方联系电话"
								maxlength="11"></el-input>
						</el-form-item>
					</el-col>
          <el-col :md="12" :lg="12">
						<el-form-item label="乙方联系电话" prop="secondPhone">
							<el-input style="width: 95%;" v-model="dataForm.secondPhone" placeholder="乙方联系电话"
								maxlength="11"></el-input>
						</el-form-item>
					</el-col>
        </el-row>
        <el-row>
           <el-col :md="12" :lg="12">
						<el-form-item label="执行开始日期" prop="startDate">
							<el-date-picker style="width: 95%;" v-model="dataForm.startDate" start-placeholder="开始日期"
								align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
					</el-col>
          <el-col :md="12" :lg="12">
						<el-form-item label="执行结束日期" prop="endDate">
							<el-date-picker v-model="dataForm.endDate" style="width: 95%;" end-placeholder="结束日期"
								align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
					</el-col>
        </el-row>
        <el-row>
          <el-col :md="12" :lg="12">
						<el-form-item label="平台服务费" prop="payFee">
							<el-input style="width: 95%;" v-model="dataForm.payFee" placeholder="请输入比例">
								<i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i></el-input>
						</el-form-item>
					</el-col>
          
          <!-- <el-col :md="12" :lg="12">
						<el-form-item label="服务费承担方" prop="serviceFeeType">
							<el-radio-group v-model="dataForm.serviceFeeType">
								<el-radio :label="0">企业承担服务费</el-radio>
								<el-radio :label="1">个人承担服务费</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col> -->
        </el-row>
        <el-form-item prop="platContractFileDTOList" label="附件">
          <el-upload class="upload-demo" :action="url" :on-remove="handleRemove"  :before-remove="beforeRemove" multiple :limit="20"
            :on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
            :on-success="successHandle" :file-list="fileList">
            <el-button size="small" type="primary" v-if="fileList.length == 0">上传附件</el-button>
            <div slot="tip" class="el-upload__tip" v-if="fileList.length == 0">支持上传PDF、图片等</div>
          </el-upload>
        </el-form-item>

























				<!-- <el-row>
					<el-col :md="12" :lg="8">
						<el-form-item label="合同类别" >
							<el-input :disabled="true" value="企业合同" style="width: 95%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方主体" :prop="power == 'OPERATE'? 'firstId' : ''">
							<el-input v-if=" power == 'COMPANY'" v-model="dataForm.firstBody" placeholder="甲方主体"  readonly show-word-limit></el-input>
							<el-select v-if="power == 'OPERATE'" v-model="dataForm.firstBody" placeholder="甲方主体" filterable  @change="jiafang"
								style="width: 95%;">
								<el-option v-for="platBody in firstBody" :key="platBody.id" :label="platBody.caName"
									:value="platBody.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方主体" >
							 <el-input
									 v-model="dataForm.secondBody"
									 readonly
									 placeholder="乙方主体"
									 show-word-limit>
							 </el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="合同金额" >
							<el-input v-model="dataForm.money" type="number" style="width: 95%;" placeholder="合同金额">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方开户行" >
							<el-input v-model="dataForm.firstBankName" readonly placeholder="甲方开户行"
								style="width: 95%;" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方开户行" >
							<el-input v-model="dataForm.secondBankName" readonly placeholder="乙方开户行" maxlength="50"
								style="width: 95%;" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="任务属性" prop="settleType">
							<ren-select v-model="dataForm.settleType" style="width: 95%;" dict-type="settleType">
							</ren-select>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方账户" >
							<el-input v-model="dataForm.firstBankAccount" readonly placeholder="甲方账户"
								style="width: 95%;" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方账户" >
							<el-input v-model="dataForm.secondBankAccount" readonly placeholder="乙方账户"
								style="width: 95%;" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="发票类型" prop="ticketType">
							<ren-select v-model="dataForm.ticketType" style="width: 95%;" dict-type="ticketType">
							</ren-select>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方地址" >
							<el-input v-model="dataForm.firstAddress" readonly placeholder="甲方地址" maxlength="100"
								style="width: 95%;" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方地址" >
							<el-input v-model="dataForm.secondAddress" readonly placeholder="乙方地址" maxlength="100"
								style="width: 95%;" show-word-limit></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :md="12" :lg="8">
						<el-form-item label="平台服务费" prop="payFee">
							<el-input style="width: 95%;" v-model="dataForm.payFee" placeholder="请输入比例">
								<i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i></el-input>
						</el-form-item>
					</el-col>

					<el-col :md="12" :lg="8">
						<el-form-item label="甲方联系人" prop="firstUser">
							<el-input v-model="dataForm.firstUser" style="width: 95%;" placeholder="甲方联系人"
									   	 show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方联系人" prop="secondUser">
							<el-input v-model="dataForm.secondUser" style="width: 95%;" placeholder="乙方联系人"
									   show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="24" :lg="8">
						<el-form-item label="执行开始日期" prop="startDate">
							<el-date-picker style="width: 95%;" v-model="dataForm.startDate" start-placeholder="开始日期"
								align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方联系电话" prop="firstPhone">
							<el-input style="width: 95%;" v-model="dataForm.firstPhone" placeholder="甲方联系电话"
								maxlength="11"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方联系电话" prop="secondPhone">
							<el-input style="width: 95%;" v-model="dataForm.secondPhone" placeholder="乙方联系电话"
								maxlength="11"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="24" :lg="8">
						<el-form-item label="执行结束日期" prop="endDate">
							<el-date-picker v-model="dataForm.endDate" style="width: 95%;" end-placeholder="结束日期"
								align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="甲方社会信用代码" >
							<el-input style="width: 95%;" v-model="dataForm.firstTaxCode" placeholder="甲方社会信用代码"
									  readonly></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="8">
						<el-form-item label="乙方社会信用代码" >
							<el-input style="width: 95%;" v-model="dataForm.secondTaxCode" placeholder="乙方社会信用代码"
									  readonly></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="结算方式" prop="serviceFeeType">
							<el-radio-group v-model="dataForm.serviceFeeType">
								<el-radio :label="0">企业承担服务费</el-radio>
								<el-radio :label="1">个人承担服务费</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>

				<el-form-item label="合同说明" prop="remark">
					<el-input style="width: 95%;" type="textarea" v-model="dataForm.remark" placeholder="非必填"
						maxlength="200" show-word-limit :autosize="{ minRows: 6, maxRows: 10}"></el-input>
				</el-form-item>
				<el-form-item prop="platContractFileDTOList" label="附件">
					<el-upload class="upload-demo" :action="url" :on-remove="handleRemove" multiple :limit="20"
						:on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
						:on-success="successHandle" :file-list="fileList">
						<el-button size="small" type="primary">上传附件</el-button>
						<div slot="tip" class="el-upload__tip">支持上传PDF、图片等</div>
					</el-upload>
				</el-form-item> -->
			</el-form>

		</div>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      power:Cookies.get('admin_role'),
      visible: false,
      firstBody: [],
      secondBody: [],
      loadingbut: false,
      dataForm: {
        id: '',
        contractType: 'qyht',
        money: '',
        settleType: '',
        ticketType: '',
        startDate: '',
        endDate: '',
        remark: '',
        firstId: '',
        firstBody: '',
        firstBankName: '',
        firstBankAccount: '',
        firstUser: '',
        firstPhone: '',
        firstAddress: '',
        firstTaxCode: '',
        payFee: '',
        secondBody: '',
        secondId: '',
        secondBankName: '',
        secondBankAccount: '',
        secondUser: '',
        secondPhone: '',
        secondAddress: '',
        inStatus: '',
        secondTaxCode: '',
        platContractFileDTOList: [],
        // serviceFeeType : '',
      },
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      num: 0,
      fileList: []
    }
  },
  computed: {
    dataRule () {
      var checkint = (rule, value, callback) => {
        let reg = /^\d+(\.\d{1,2})?$/;
        if (reg.test(value)&&parseFloat(value)<=100) {
          callback()
        } else {
          callback(new Error('请输入小于等于100的数字,最大保留两位小数'))
        }
      }
      var checkfloat = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入数字值,并且最多两位小数'))
        }
      }
      var checkphone = (rule, value, callback) => {
        if (/^1\d{10}$/.test(value)) {
          callback()
        } else if (/^0\d{2,3}-?\d{7,8}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入手机号'))
        }
      }
      var checkcard = (rule, value, callback) => {
        if (/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
          .test(value)) {
          callback()
        } else {
          callback(new Error('请输入身份证号'))
        }
      }
      var checkbank = (rule, value, callback) => {
        if (/^([A-Za-z0-9]{9}|[A-Za-z0-9]{12}|[A-Za-z0-9]{16}|[A-Za-z0-9]{17}|[A-Za-z0-9]{15}|[A-Za-z0-9]{19})$/.test(value)) {
          // if(/^([1-9]{1})(\d{14}|\d{18})$/.test(value)){
          callback()
        } else {
          callback(new Error('请输入卡号'))
        }
      }

      var checkNumtwo = (rule, value, callback) => {
        if (/^[A-Za-z0-9]{7,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('社会信用代码格式错误'))
        }
      }

      var validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          return callback(new Error(this.$t('validate.format', {
            'attr': this.$t('user.email')
          })))
        }
        callback()
      }
      return {
        contractType: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        money: [{
          required: true,
          message: '请输入数字值,并且最多两位小数',
          validator: checkfloat,
          trigger: 'blur'
        }],
        payFee: [{
          required: true,
          validator: checkint,
          trigger: 'blur'
        }],
        secondBody:[{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change'
        }],
        settleType: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        ticketType: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        startDate: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        endDate: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        // remark: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        firstId: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        firstBankName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        firstTaxCode: [{
          required: true,
          message: '格式错误，7-20位数字或字母',
          validator: checkNumtwo,
          trigger: 'blur'
        }],
        secondTaxCode: [{
          required: true,
          message: '格式错误，7-20位数字或字母',
          validator: checkNumtwo,
          trigger: 'blur'
        }],
          serviceFeeType: [
              { required: false, message: '必选项不能为空', trigger: 'blur' }
          ],
        firstBankAccount: [{
          required: true,
          message: '请输入卡号',
          trigger: 'blur'
        },{ message: '银行卡号错误，请检查位数'
        ,validator: checkbank,
        trigger: 'blur'}],
        firstUser: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        firstPhone: [{
          required: true,
          message: '输入正确的电话号码',
          trigger: 'blur'
        }],
        firstAddress: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        secondId: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        secondBankName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        secondBankAccount: [{
          required: true,
          message: '请输入卡号',
          trigger: 'blur'
        },{ message: '银行卡号错误，请检查位数'
        ,validator: checkbank,
        trigger: 'blur'}],
        secondUser: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        secondPhone: [{
          required: true,
          message: '输入正确的电话号码',
          trigger: 'blur'
        }],
        secondAddress: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        platContractFileDTOList: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }]
      }
    }
  },
  created () {
    this.url = `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`
    this.num = 0
    this.fileList = []
    this.dataForm.id = this.$route.params.id || '';
    
//	如果是运营端，获取甲方信息
    if(this.power == 'OPERATE' )this.$http.get(`/sys/plat/info/ca/list`).then(({data: res}) => { 
      this.firstBody = res.data 
      
    }).catch(() => {})
      //	如果是企业端，获取甲方信息和乙方信息
    if(this.power == 'COMPANY' ){
        this.infoPartyA(); this.infoPartyB()
	}
    this.init()
  },
  methods: {
    // 选择乙方税源地
    sydChange(e){
      let info =  e;
      this.dataForm.secondBody = info.abbreviation
      this.dataForm.secondBankName = info.bankName
      this.dataForm.secondBankAccount = info.bankAccount
      this.dataForm.legalPersonName = info.taxOfficerName
      this.dataForm.legalPersonPhone = info.phone
      this.dataForm.secondAddress = info.address
      this.dataForm.secondId = info.id
      this.dataForm.secondTaxCode = info.taxCode
      this.dataForm.secondUser = info.legalPersonName;
      this.dataForm.secondPhone = info.legalPersonPhone;
      this.$refs["dataForm"].validateField('secondUser');
      this.$refs["dataForm"].validateField('secondPhone');

    },
//      获取甲方信息
      infoPartyA( getId ){
          this.$http.get(`/sys/plat/info/ca/list`).then(({data: res}) => {
                  if (res.code !== 0) return this.$message.error(res.msg);
              			this.firstBody = res.data
                  // if (this.dataForm.id <= 0) {
                      let info = [];
                      if( getId ){
                          this.dataForm.firstId = getId
                          for (let i = 0; i < this.firstBody.length; i++) {
                              if (this.firstBody[i].id == getId) {
                                  info = this.firstBody[i]
                              }
                          }
                      }else{
                          this.dataForm.firstId = res.data[0].id
                          info = this.firstBody[0];
                      }
                      this.dataForm.firstBody = info.caName
                      this.dataForm.firstBankName = info.bankName
                      this.dataForm.firstBankAccount = info.bankAccount
                      this.dataForm.firstUser = info.contacts
                      this.dataForm.firstPhone = info.phone
                      this.dataForm.firstAddress = info.address
                      this.dataForm.firstTaxCode = info.taxCode
                  // }
                  }).catch(() => {})
                  
	  },
//	  获取乙方信息
      infoPartyB(getId){
        
          if(getId){
              this.$http.get(`/sys/plat/body/getBankAccountByCaIdOrUserId?caId=${getId}`).then(({data: res}) => {
                  if (res.code !== 0)  return this.$message.error(res.msg)
                  // this.dataForm.secondId = res.data.id
                  this.secondBody = res.data
                  // this.yifang()
              }).catch(() => {})
		  }else{
              this.$http.get(`/sys/plat/body/getBankAccountByCaIdOrUserId`).then(({data: res}) => {
                  if (res.code !== 0)  return this.$message.error(res.msg)
                  // this.dataForm.secondId = res.data.id
                  this.secondBody = res.data
                  // this.yifang()
              }).catch(() => {})
		  }
	  },
    backerror (e) {
      this.$message.error('文件上传失败，请重试')
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        this.fileList = [];
        if (this.dataForm.id > 0) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
        .get(`/sys/plat/contract/${this.dataForm.id}`)
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          this.fileList = []
          if (res.data.platContractFileDTOList.length > 0) {
            let filelist = res.data.platContractFileDTOList
            for (let i = 0; i < filelist.length; i++) {
              let info = []
              info.status = 'success'
              filelist[i].url = filelist[i].filePath
              info.name = filelist[i].fileName + '.' + filelist[i].fileType
              info.response = []
              info.response.code = 0
              info.response.msg = 'success'
              info.response.data = filelist[i]
              this.fileList.push(info)
            }
          }
          if(this.dataForm.id){
            this.infoPartyB(this.dataForm.firstId)
          }
        })
        .catch(() => {})
    },
    beforeUploadHandle (file) {
      if (file.type != 'application/pdf' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file
        .type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error(this.$t('upload.tip', {
          'format': 'jpg、png、gif,pdf,xls,xlsx'
        }))
        return false
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件太大，只能上传30MB以内的文件')
        return false
      }
      this.num++
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.fileList = fileList
      this.dataForm.platContractFileDTOList = fileList
    },
    beforeRemove(file,fileList){
      if(file.status == 'success')
		  return this.$confirm(`确定移除 ${ file.name }？`);
    },
    // 上传成功
    successHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }

      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.fileList = fileList
      this.dataForm.platContractFileDTOList = fileList
      this.num--
      this.$refs["dataForm"].validateField('platContractFileDTOList');
    },
    handlePreview (file) {
      if (!file.response.data.url) {
        this.$message.error('下载失败')
        return
      }
      const type = file.response.data.url.split('.')[4]
      // 判断文件类型
      if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type ===
					'pptx') {
        // 在当前浏览器直接下载
        document.location.href = file.response.data.url
      } else {
        // 图片在浏览器打开 新的页面展示
        window.open(file.response.data.url, file.name)
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function (inStatus) {
        this.dataForm.inStatus = inStatus
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          if (this.fileList.length == 0) {
            return this.$message.error('请上传附件')
          }
          this.loadingbut = true
          let fileinfo = []
          let fileList = this.fileList
          for (let i = 0; i < fileList.length; i++) {
            fileinfo.push({
              id: fileList[i].response.data.id,
              contractId: this.dataForm.id,
              fileName: fileList[i].response.data.fileName,
              filePath: fileList[i].response.data.url,
              url: fileList[i].response.data.url,
              fileType: fileList[i].response.data.fileType,
              createDate: ''
            })
          }

          for (let i = 0; i < this.firstBody.length; i++) {
            if (this.firstBody[i].id == this.dataForm.firstId) {
              this.dataForm.firstBody = this.firstBody[i].caName
            }
          }
          for (let i = 0; i < this.secondBody.length; i++) {
            if (this.secondBody[i].id == this.dataForm.secondId) {
              this.dataForm.secondBody = this.secondBody[i].abbreviation
            }
          }

          this.dataForm.platContractFileDTOList = fileinfo

          this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/contract/', this.dataForm)
            .then(({
              data: res
            }) => {
              this.loadingbut = false
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: (inStatus == 1 ? '提交成功' : '保存成功'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  if (inStatus == 1) {
                    this.$router.back(-1)
                  } else {
                    this.dataForm.id = res.data
                    this.getInfo()
                  }
                }
              })
            })
            .catch(() => {})
        })
      },
      1000, {
        leading: true,
        trailing: false
      }
    ),
    jiafang (Id) {
      this.secondBody = []
      this.dataForm.firstBody = '',
      this.dataForm.firstBankName = '',
      this.dataForm.firstBankAccount = '',
      this.dataForm.firstUser = '',
      this.dataForm.firstPhone = '',
      this.dataForm.firstAddress = '',
      this.dataForm.firstTaxCode = '',
      this.dataForm.secondBody = '',
      this.dataForm.secondBankName = '',
      this.dataForm.secondBankAccount = '',
      this.dataForm.legalPersonName = '',
      this.dataForm.legalPersonPhone = '',
      this.dataForm.secondAddress = '',
      this.dataForm.secondTaxCode = '',
      this.dataForm.secondUser = '';
      this.dataForm.secondPhone = '';
      this.infoPartyA(Id)
      this.infoPartyB(Id)
    },
    yifang () {
      let info =  this.secondBody;
      this.dataForm.secondBody = info.abbreviation
      this.dataForm.secondBankName = info.bankName
      this.dataForm.secondBankAccount = info.bankAccount
      this.dataForm.legalPersonName = info.taxOfficerName
      this.dataForm.legalPersonPhone = info.phone
      this.dataForm.secondAddress = info.address
      this.dataForm.secondTaxCode = info.taxCode
      this.dataForm.secondUser = info.legalPersonName;
      this.dataForm.secondPhone = info.legalPersonPhone;
    }
  }
}
</script>
